// src/services/projectService.js
import api from './api';

/**
 * Получает список всех проектов (для селектов, форм)
 */
export const fetchAllProjects = async () => {
  try {
    const res = await api.get('/projects'); // ✅ Исправлено: /projects
    return res.data.projects || []; // ✅ Только проекты
  } catch (err) {
    console.error('Ошибка при загрузке проектов:', err);
    return [];
  }
};

/**
 * Получает список всех проектов с полной информацией
 */
export const getAllProjects = async () => {
  try {
    const res = await api.get('/projects');
    return res.data.projects || [];
  } catch (err) {
    console.error('Ошибка при загрузке проектов:', err);
    return [];
  }
};

/**
 * Получает пользователей проекта
 */
export const getProjectUsers = async (projectId) => {
  try {
    const res = await api.get(`/project/${projectId}/users`);
    return res.data.users || [];
  } catch (err) {
    console.error(`Ошибка при загрузке пользователей проекта ${projectId}:`, err);
    return [];
  }
};

/**
 * Добавляет пользователя в проект
 */
export const addUserToProject = async (projectId, userId) => {
  try {
    await api.post(`/projects/${projectId}/add_user`, { user_id: userId });
    return { success: true };
  } catch (err) {
    const error = err.response?.data?.error || 'Не удалось добавить пользователя';
    return { success: false, error };
  }
};

/**
 * Удаляет пользователя из проекта
 */
export const removeUserFromProject = async (projectId, userId) => {
  try {
    await api.post(`/projects/${projectId}/remove_user`, { user_id: userId });
    return { success: true };
  } catch (err) {
    const error = err.response?.data?.error || 'Не удалось удалить пользователя';
    return { success: false, error };
  }
};

/**
 * Обновляет имя softphone для проекта
 */
export const updateSoftphoneName = async (projectId, name) => {
  try {
    await api.post(`/projects/${projectId}/softphone`, { softphone_name: name });
    return { success: true };
  } catch (err) {
    const error = err.response?.data?.error || 'Не удалось обновить имя';
    return { success: false, error };
  }
};

/**
 * Переключает статус проекта (вкл/выкл)
 */
export const toggleProjectStatus = async (projectId) => {
  try {
    await api.post(`/projects/${projectId}/toggle`);
    return { success: true };
  } catch (err) {
    const error = err.response?.data?.error || 'Не удалось изменить статус';
    return { success: false, error };
  }
};

/**
 * Удаляет проект
 */
export const deleteProject = async (projectId) => {
  try {
    await api.delete(`/projects/${projectId}`);
    return { success: true };
  } catch (err) {
    const error = err.response?.data?.error || 'Не удалось удалить проект';
    return { success: false, error };
  }
};

export default {
  fetchAllProjects,
  getAllProjects,
  getProjectUsers,
  addUserToProject,
  removeUserFromProject,
  updateSoftphoneName,
  toggleProjectStatus,
  deleteProject,
};

